import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { Formik } from "formik";

import CustomNavbar from "../../components/CustomNavbar";
import CustomTable from "../../components/CustomTable";
import CustomPagint from "../../components/CustomPagint";
import {
  getJobPositions,
  saveJobPosition,
  editJobPosition,
  deleteJobPosition,
} from "../../redux/jobposition/actions";
import messages from "../../redux/messages";
import SidebarConfig from "../../components/SidebarConfig";

const JobPosition = (props) => {
  const schema = Yup.object().shape({
    codigo: Yup.string()
      // .matches(/[A-Za-z0-9]+/, "**Solo admite números y letras")
      .required("**Campo requerido"),
    descripcion: Yup.string()
      // .matches(
      //   /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/,
      //   "**Solo admite letras"
      // )
      .required("**Campo requerido"),
    activo: Yup.boolean().notRequired(""),
  });

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);

  const dispatch = useDispatch();
  const {
    jobPositions,
    jobPositionsLength,
    loading,
    saveLoading,
    jobPositionsError,
    formError,
  } = useSelector((store) => store.jobPositions);
  const pages = Math.ceil(jobPositionsLength / limit);

  const columns = [
    {
      Header: "Código",
      accessor: "codigo",
    },
    {
      Header: "Nombre",
      accessor: "descripcion",
    },
    {
      Header: "Activa",
      accessor: "activo",
      Filter: "",
      Cell: (value) => (
        <div
          className={`${
            value.row.original.activo
              ? "bg-success text-light"
              : "bg-danger text-light"
          } p-2 rounded-pill text-center`}
        >
          {value.row.original.activo ? "Activa" : "Inactiva"}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  // Métodos
  const getJobsPosi = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getJobPositions(
        {
          offset: offs,
          limit: lim,
          filter: filt,
        },
        parseInt(props.match.params.type)
      )
    );

  useEffect(() => {
    getJobsPosi();
  }, [props.match.params.type]);

  const addJobPosition = () => {
    setShowModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    if (!e.target.filter.value.trim()) {
      return;
    }
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getJobsPosi(oOffset, limit, e.target.filter.value);
  };

  const onSubmitJobPosition = (req) => {
    req.unidad_organizativa = [];
    if (!edit) {
      req.activo = true;
      dispatch(
        saveJobPosition(req, parseInt(props.match.params.type), setShowModal)
      );
    } else {
      dispatch(
        editJobPosition(
          req,
          editItem.id,
          index,
          parseInt(props.match.params.type),
          setShowModal
        )
      );
    }
  };

  const seeAll = () => {
    const ofilter = "";
    setFilter(ofilter);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getJobsPosi(oOffset, limit, ofilter);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteJobPosition(id, index, parseInt(props.match.params.type)));
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="font-weight-bold text-uppercase">Posición</h5>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                {/* <Col xs="auto">
                  <Form.Control
                  onChange={ e => setFilter(e.target.value)}
                  placeholder="Buscar"
                  className="rounded-pill form-control-sm"
                  type="search"></Form.Control>
                </Col> */}
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle mr-1"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                      onClick={() => addJobPosition()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            jobPositionsLength > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable columns={columns} data={jobPositions} />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={jobPositionsLength}
                  pages={pages}
                  pagFunc={getJobsPosi}
                />
              </>
            )
          )}
          {!loading && jobPositionsLength === 0 && jobPositionsError === "" && (
            <Alert variant="info" className="my-4">
              Aún no hay puestos, comienza agregando algunos
            </Alert>
          )}
          {!loading && !!jobPositionsError && (
            <Alert variant="danger" className="my-4">
              {jobPositionsError}
            </Alert>
          )}
        </Container>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmitJobPosition}
          initialValues={{
            codigo: edit ? editItem.codigo : "",
            descripcion: edit ? editItem.descripcion : "",
            activo: edit ? editItem.activo : true,
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title>
                  {edit ? "Editar puesto" : "Crear puesto"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formError && (
                  <Alert variant="danger" className="my-1">
                    {formError}
                  </Alert>
                )}
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="12" md="4">
                    Código
                  </Form.Label>
                  <Col sm="12" md="8">
                    <Form.Control
                      id="codigo"
                      name="codigo"
                      isInvalid={touched.codigo && errors.codigo}
                      isValid={touched.codigo && !errors.codigo}
                      onBlur={handleBlur("codigo")}
                      onChange={handleChange}
                      value={values.codigo}
                      className="rounded-pill"
                      type="text"
                      placeholder="Código"
                    ></Form.Control>
                    {touched.codigo && errors.codigo && (
                      <div>
                        <small className="text-danger mx-2">
                          {errors.codigo}
                        </small>
                      </div>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="12" md="4">
                    Nombre
                  </Form.Label>
                  <Col sm="12" md="8">
                    <Form.Control
                      id="descripcion"
                      name="descripcion"
                      isInvalid={touched.descripcion && errors.descripcion}
                      isValid={touched.descripcion && !errors.descripcion}
                      onBlur={handleBlur("descripcion")}
                      onChange={handleChange}
                      value={values.descripcion}
                      className="rounded-pill"
                      type="text"
                      placeholder="Nombre"
                    ></Form.Control>
                    {touched.descripcion && errors.descripcion && (
                      <div>
                        <small className="text-danger mx-2">
                          {errors.descripcion}
                        </small>
                      </div>
                    )}
                  </Col>
                </Form.Group>
                {edit && (
                  <Form.Group
                    as={Row}
                    className="d-flex aling-items-between justify-content-between mb-3"
                  >
                    <Form.Label column xs="auto">
                      ¿La posición está activa?
                    </Form.Label>
                    <Col xs="auto">
                      <Form.Check
                        id="activo"
                        name="activo"
                        isInvalid={touched.activo && errors.activo}
                        isValid={touched.activo && !errors.activo}
                        onBlur={handleBlur("activo")}
                        onChange={(e) => {
                          setFieldValue("activo", e.target.checked);
                        }}
                        value={values.activo}
                        className="rounded-pill"
                        type="switch"
                        defaultChecked={edit ? editItem.activo : null}
                      />
                      {touched.activo && errors.activo && (
                        <div>
                          <small className="text-danger mx-2">
                            {errors.activo}
                          </small>
                        </div>
                      )}
                    </Col>
                  </Form.Group>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={saveLoading}
                  variant="primary"
                  type="submit"
                >
                  {saveLoading && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default JobPosition;
